import { useEffect, useState } from "react"
import { OTHER_DROPDOWN_OPTION } from "../constants";

/**
 * This hook is used to determine if the "Other" option is selected from a dropdown
 * on the Registration page.
 * 
 * @param dropdownData - the array of dropdown data fetched from the database
 * @param selectedItemID - the ID of the currently selected dropdown item
 * @param property - the name of the property in the dropdown option object that contains the label text 
 * (ex. the 'shirtSize' property for the Shirt Size dropdown)
 * 
 * @returns a boolean that determines if the "Other" option is currently selected and a function for setting that boolean
 */
const useSetOtherSelected = (dropdownData, selectedItemID, property) => {
    const [otherSelected, setOtherSelected] = useState(false);

    useEffect(() => {
        const selectedItem = dropdownData.find((item) => Number(item.id) === Number(selectedItemID));
        if (selectedItem) {            
            if (selectedItem[property] === OTHER_DROPDOWN_OPTION) {
                setOtherSelected(true);
            } else {
                setOtherSelected(false);
            }
        }
    }, [selectedItemID]);

    return [otherSelected, setOtherSelected];
};

export default useSetOtherSelected;